import { forwardRef, useMemo } from "react";

import { Icons } from "widgets";

import { Tile } from "../../../../modules/core/components/Tile.js";
import { getEventTagIntent, getTagIntentColor } from "@/app-utils/events.ts";
import type { BlastJob } from "@/graphql.ts";
import { JobStatusEnum } from "@/graphql.ts";

interface JobEventTileProps {
  job: BlastJob;
}

const JobEventTile = forwardRef<HTMLDivElement, JobEventTileProps>(function JobEventTile(props, ref) {
  const statusIntent = useMemo(() => getEventTagIntent(props.job.status), [props.job]);

  // TODO show the error in the tooltip
  // => props.job.errorDescription

  return (
    <Tile
      dates={{ created: props.job.created }}
      users={{ creator: props.job.owner }}
      title={props.job.name}
      type={`${(props.job.params?.blast?.blastType ?? props.job.tool ?? "BLAST").toUpperCase()} Job`}
      to={`/job/${props.job.id}`}
      icon={<img src={Icons.Tiles.Blast} width={24} height={30} />}
      // We don't show explicitly a tag when an Event is completed. This is the default awaited behavior of the application
      tags={
        props.job.status !== JobStatusEnum.Completed
          ? [{ intentColor: statusIntent, label: props.job.status }]
          : undefined
      }
      eventStatusBulletColor={getTagIntentColor(statusIntent) ?? null}
      ref={ref}
    />
  );
});

export { JobEventTile };
